import { Dropdown, DropdownProps } from 'primereact/dropdown';

import { useGetSitesQuery } from '@/app/services/lookups';
import { useFreshShipmentListQuery } from '@/services/fresh-shipment/hooks';

import './FreshShipmentsDropdown.css';

type FreshShipmentDropdownProps = DropdownProps & {
  className?: string;
  label?: string;
  fertDate: string;
  fertSiteId: string;
};

export const FreshShipmentsDropdown = ({
  className,
  label,
  fertDate,
  fertSiteId,
  ...dropdownProps
}: FreshShipmentDropdownProps) => {
  const { data: siteData } = useGetSitesQuery(
    { where: { id: { eq: fertSiteId } } },
    { skip: !fertSiteId },
  );
  const siteName = siteData?.[0]?.name;

  const { data: freshShipmentsData, isLoading } = useFreshShipmentListQuery({
    fertilizationDate: fertDate as string,
    fertilizationSiteId: fertSiteId as string,
    fertilizationSiteName: siteName as string,
  });

  const options = freshShipmentsData?.map((item) => ({
    value: item.freshShipmentId,
    label: item.name,
  }));

  return (
    <div
      className={`fertilization-site-dropdown${label ? 'label-input-group' : ''}`}
    >
      {label && <label>{label}</label>}
      <Dropdown
        appendTo="self"
        options={options}
        filter
        filterPlaceholder="Search"
        filterInputAutoFocus={true}
        loading={isLoading}
        showClear
        {...dropdownProps}
      />
    </div>
  );
};
